export const selectCompnay = `select_company`
export const goButton = `button_go`
export const goButtonDate = `button_go_date`
export const selBranch = `select_company_branch`
export const fromDate = `from_date_id`
export const toDate = `to_date_id`
export const summaryCheck = `summary_check_box`
export const showOnlyAutoRec = `show_only_autoreceive_check_box`
export const branchSummaryCheck = `branch_summary_check_box`
export const isOnlyDestRec = `is_only_dest_receive_check_box`
export const detailedCheck = `detailed_check_box`
export const destination = `destination_city`
export const destinationBranch = `destination_branch`
export const onlyRefund = `only_refund`
export const userLIst = `users_list`
export const paymentBookingType = `payment_type`
export const franchiseCompany = `franchise_company`
export const franchiseBranch = `franchise_branch`
export const reportmainButton = `report_go_button`
export const dispatchByBranch = `dispatch_by_branch`
export const vehicle = `Vehicle`
export const selectBranch = 'select_branch'
export const transactionType = `transaction_type`
//QuickView Report
export const branchWiseCheck = `branchwise_check_box`
export const bookingCity = `booking_city`
export const bookingBranch = `booking_branch`
export const destCity = `dest_city`
export const destBranch = `dest_branch`
export const splitButton = `split_button`
export const bookingType = `booking_type`
export const paymentType = `payment_type`
export const cityId = `city_id`
export const stateId = `state_id`
export const partyAS = `party_as`
export const party = `party`
export const recParty = `receiver_party`
export const user = `user`
export const extendedVersion = `extended_version`
export const nonMoveDays = `non_movement_days`
export const status = `status`
export const summaryFilter = `summary_filter`
export const detailedFilter = `detailed_filter`
export const financialYear = 'financial_year'
export const showTransaction = 'show_Transaction'
export const SelectDays = `Select_Days`
export const ReportOptions = 'report_Options'
export const crossingTransactions = 'crossing_Transactions'
export const reportView = 'report_view'
export const reportType = 'report_type'

//Analysis report
export const anlsFromDate = `anls_From_date_id`
export const anlsToDate = `anls_To_date_id`
export const anlsGoButton = `anls_Go_Button`
export const anSourceCity = 'an_sourceCity'
export const anSourceBranch = 'an_sourceBranch'
export const anDestinationCity = 'an_destinationCity'
export const anDestinationBranch = 'an_destinationBranch'
export const anPaymentType = 'an_PaymentType'
export const anView = 'an_view'
export const anReportOptions = 'an_reportOptions'
export const anReportGroupByOptions = 'an_reportGroupByOptions'
export const anSplitButton = 'an_splitButton'

//Received Report
export const recvdSourceCity = 'recvd_sourceCity'
export const recvdSourceBranch = 'recvd_sourceBranch'
export const recvdReceivedCity = 'recvd_destinationCity'
export const recvdReceivedBranch = 'recvd_destinationBranch'
export const recvdPaymentType = 'recvd_PaymentType'
export const recvdView = 'recvd_view'
export const recvdReportOptions = 'recvd_reportOptions'
export const recvdBookingType = 'recvd_bookingType'
export const recvdReceivedType = 'recvd_receivedType'

//Good Balance Report
export const gbSourceCity = 'gb_sourceCity'
export const gbSourceBranch = 'gb_sourceBranch'
export const gbDestinationCity = 'gb_destinationCity'
export const gbDestinationBranch = 'gb_destinationBranch'
export const gbPaymentType = 'gb_PaymentType'
export const gbView = 'gb_view'
export const gbReportType = 'gb_ReportType'
//Franchisee To Own
export const ftoCity = 'franchiseCity'
export const ftoBranch = 'franchiseToOwnBranch'
export const ftoBranchUser = 'franchiseBranchUser'
export const ftoDestinationCity = 'franchiseDestinationCity'
export const ftoDestinationBranch = 'franchiseDestinationBranch'
export const ftoGoButton = 'francToOwnGoButton'
export const ftoPaymentType = 'ftoPaymentType'
export const ftoTransactionType = 'ftoTransactionType'
export const ftoReportView = 'ftoReportView'
export const ftoLrStatus = 'ftoLrStatus'
export const ftoisCrossingCheck = 'ftoisCrossingCheck'
export const ftoSplitButton = 'ftoSplitButton'

//On Account Credit
export const onAcBookingBranch = 'onAcBookingBranch'
export const onAcUser = 'onAcUser'
export const onAcParty = 'onAcParty'
export const onAcRecParty = 'onAcRecParty'
export const onAcPartyAs = 'onAcPartyAs'
export const onAcSplitButton = 'onAcSplitButton'
export const onAcFromDate = 'onAconAcFromDate'

export const FranchiseeDelCity='FranchiseeDelCity'
export const FranchiseeDelBranch='FranchiseeDelBranch'
export const OwnBookingCity='OwnBookingCity'
export const OwnBookingBranch='OwnBookingBranch'
export const OwnBkgBranchUser='OwnBkgBranchUser'
export const PaymentMode='PaymentMode'


